import config from 'config.json';
import React from 'react';
import FontAwesome from 'react-fontawesome';

import Crew from './Crew';
import DispatchMap from './DispatchMap';
import EventsPreview from './EventPreview';

import styles from './Dispatcher.css';

const Dispatcher = ({
  activeCrew,
  defaultCenter,
  eventsByCrew,
  mapEvents,
  onCrewSelect,
  onDispatch,
  onPreviewEvent,
  previewEvent,
  unassignedEvents
}) => (
  <div className={styles.dispatcher}>
    <div className={styles.mapContainer}>
      <DispatchMap
        googleMapURL={config.googleMapURL}
        defaultCenter={defaultCenter}
        events={mapEvents}
        containerElement={<div className={styles.dispatcher} />}
        mapElement={<div className={styles.dispatcher} />}
        onPreviewEvent={onPreviewEvent}
        onEventClick={(event) => onDispatch(event.id)}
        loadingElement={
          <div className={styles.spinnerStyle}>
            <FontAwesome name="fa-spinner" spin />
          </div>
        }
      />
    </div>
    <div className={styles.flexListContainer}>
      <EventsPreview event={previewEvent} />
      <div className={styles.flexGrow}>
        {eventsByCrew.map(({ active, crew, events }) => (
          <Crew
            active={active}
            crew={crew}
            events={events}
            key={crew.id}
            onCrewSelect={onCrewSelect}
          />
        ))}
      </div>
    </div>
    <div className={styles.listContainer}>
      <Crew
        active={!activeCrew}
        crew={null}
        events={unassignedEvents}
        onCrewSelect={onCrewSelect}
      />
      {!!activeCrew && (
        <Crew
          active={true}
          crew={activeCrew ? eventsByCrew.find(c => c.active).crew : null}
          events={activeCrew ? eventsByCrew.find(c => c.active).events : []}
          onCrewSelect={onCrewSelect}
        />
      )}
    </div>
  </div>
);

export default Dispatcher;
